import graphql from 'babel-plugin-relay/macro';

export const meQuery = graphql`
query UserMeQuery {
  me
}
`;
